import { KeyValuePair } from 'src/app/interfaces/views.interface';

const UNITS_SYSTEM_PROPERTIES = ['Agency', 'Handler', 'SiteId'];

/**
 * Cleans node metadata by removing system properties
 * @param productId ID of the Product which which this metadata came from
 * @param metadata Metadata as defined on the node
 * @returns The cleaned metadata
 */
export function cleanMetadata(productId: string, metadata: KeyValuePair[]): KeyValuePair[] {
	if (!metadata?.length) return metadata;

	// Filter out system properties from UNITS metadata
	if (productId === 'UNITS') {
		metadata = metadata.filter(x => !UNITS_SYSTEM_PROPERTIES.includes(x.key));
	}

	// Flatten arrays or objects containing only primitives
	return metadata;
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
